export enum AfterSalesEnum {
  CREATED = 'CREATED',
  IN_ANALYSIS = 'IN_ANALYSIS',
  ACTIVE = 'ACTIVE',
  NOT_APPROVED = 'NOT_APPROVED',
  CANCELED = 'CANCELED',
  FINISHED = 'FINISHED',
}
